import { render, staticRenderFns } from "./TeacherArticle.vue?vue&type=template&id=1eefb28a&scoped=true"
import script from "./TeacherArticle.vue?vue&type=script&lang=js"
export * from "./TeacherArticle.vue?vue&type=script&lang=js"
import style0 from "./TeacherArticle.vue?vue&type=style&index=0&id=1eefb28a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eefb28a",
  null
  
)

export default component.exports